import Images from "../../media/images";
import { Link, Outlet } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect } from "react";
import { fetchNews } from "../../features/news/NewsSlice";
import { fetchCategory } from "../../features/news/NewsSlice";
import { useDispatch, useSelector } from "react-redux";
import NepaliDate from "nepali-date-converter";
import { fetchAd } from "../../features/adSlice/adSlice";
import { url } from "../../api/api";
import moment from "moment";
import { Helmet } from "react-helmet-async";
const News = () => {
  const { news, category } = useSelector((state) => state.news);
  const ad = useSelector((state) => state.ad);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAd());
    dispatch(fetchNews());
    dispatch(fetchCategory());
  }, [dispatch]);
  const data = [
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
    {
      name: "Tony Stark",
      desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.",
      possition: "Iron Man",
    },
  ];
  return (
    <div className=" -mt-4 w-full">
      {/* News Category */}
      <div className=" w-full">
        {news.slice(0, 2).map((items, index) => {
          console.log("news",items)
          const apiDate = Date.parse(items.created_at);
          const nepaliDate = new NepaliDate(apiDate);
          return (
            <div key={index}>
              <Helmet>
                <title>News</title>
              </Helmet>
              <div className="">
                <Link
                  to={`${items.category_name_eng}/${items.slug}`}
                  state={{
                    category: items.category,
                  }}
                >
                  <div className="inline-block w-full rounded-sm">
                    <h1 className="animation font-Poppins text-primary-blue hover:text-primary-red mx-auto mt  text-center text-2xl font-bold md:!leading-[75px] md:!text-[3rem]">
                      {items.title}
                    </h1>
                    <div className="flex justify-center  ">
                      <img
                        src={`${url}media/${items.thumbnail}`}
                        className="w-full sm:h-[20rem] lg:h-[35rem] md:h-[33rem] object-fill "
                      />
                    </div>
                    {/* <div className="md:mt-10 mt-4 pr-10">
                      <img
                        src={items.image}
                        alt=""
                        className="mx-auto h-auto w-screen rounded-md object-contain"
                      />
                    </div> */}
                    <p
                      dangerouslySetInnerHTML={{ __html: items.description }}
                      className="text-primary-blue line-clamp-2 px-3 font-Asar mt-5 text-base md:!text-2xl"
                    >
                      {/* {items.description} */}
                    </p>
                    {/* <img src={items.description} alt=""/> */}
                    <div className="mt-4 flex gap-10 px-3">
                      {/* news wirter */}
                      <div className="flex items-center gap-1">
                        {items.author_image ? (
                          <img
                            src={`${url}media/${items.author_image}`}
                            className="h-8 w-8 flex-shrink-0 rounded-full"
                            alt=""
                          />
                        ) : (
                          <img
                            className="h-8 w-10 flex-shrink-0 rounded-full"
                            // src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZmlsZXxlbnwwfHwwfHw%3D&w=1000&q=80"
                            src={Images.defaultImg}
                            alt=""
                          />
                        )}
                        <p className="text-primary-blue text-sm font-semibold">
                          {items.author_name}
                        </p>
                      </div>
                      {/* news author */}

                      {/* news date */}
                      <div className="flex items-center gap-1">
                        <svg
                          className="h-6 w-6"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 1024 1024"
                        >
                          <path
                            fill="currentColor"
                            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                          />
                          <path
                            fill="currentColor"
                            d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                          />
                        </svg>
                        <p className="text-primary-blue text-sm font-semibold">
                          {nepaliDate.toString()}
                          {/* {
                            items.created_at
                          } */}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
                <p className="border-lightBorder mt-8 w-full border-b" />
                <p className="border-lightBorder mt-2 w-full border-b" />
              </div>
            </div>
          );
        })}
      </div>

      {/* ads*/}
      <div className="w-padding">
        {ad.data
          ?.filter((item) => item.id === 1)
          .map((item, index) => {
            return (
              <div
                key={index}
                className="mx-auto my-5 grid   place-content-center  text-2xl font-bold text-white"
              >
                <img
                  src={item.image}
                  alt=""
                  className="md:h-[75px] h-[25px] w-full object-fill"
                />
              </div>
            );
          })}
      </div>
      {/* news */}
      <div className="w-padding flex flex-col w-full gap-10 lg:!flex-row">
        <div className="flex-1">
          <h1 className="font-Poppins mt-10 text-3xl font-bold text-[#2260bf] md:text-[45px]">
            {category[0]?.name_nep}
          </h1>
          {/* news mini section */}
          <div className="mt-10 grid  grid-cols-1 gap-8 md:grid-cols-2">
            {news
              .filter((value) => value.category === 1)
              .slice(0, 4)
              .map((items, index) => {
                return (
                  <div key={index}>
                    <Link
                      state={{
                        category: items.category,
                      }}
                      to={`${items.category_name_eng}/${items.slug}`}
                    >
                      <div className="grid grid-cols-2">
                        <div className="trending-text">
                          {items.title.slice(0, 40)}

                          <div className="text-sm flex gap-2 text-gray-500 mt-2">
                            <svg
                              className="h-6 w-6"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 1024 1024"
                            >
                              <path
                                fill="currentColor"
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                              />
                              <path
                                fill="currentColor"
                                d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                              />
                            </svg>

                            <span> {moment(items.created_at).fromNow()}</span>
                          </div>
                        </div>
                        <img
                          src={`${url}media/${items.thumbnail}`}
                          alt=""
                          className="h-auto w-auto rounded-md md:h-32 md:w-32"
                        />
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>
          <h1 className="font-Poppins mt-10 text-3xl font-bold text-[#2260bf] md:text-[45px]">
            {category[1]?.name_nep}
          </h1>
          <div className="mt-10 grid max-w-[1100px] grid-cols-1 gap-8 md:grid-cols-2">
            {news
              .filter((value) => value.category === 2)
              .slice(0, 4)
              .map((items, index) => {
                return (
                  <div key={index}>
                    <Link
                      to={`${items.category_name_eng}/${items.slug}`}
                      state={{
                        category: items.category,
                      }}
                    >
                      <div className="grid grid-cols-2">
                        <div className="trending-text">
                          {items.title.slice(0, 40)}

                          <div className="text-sm flex gap-2 text-gray-500 mt-2">
                            <svg
                              className="h-6 w-6"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 1024 1024"
                            >
                              <path
                                fill="currentColor"
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                              />
                              <path
                                fill="currentColor"
                                d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                              />
                            </svg>

                            <span> {moment(items.created_at).fromNow()}</span>
                          </div>
                        </div>
                        <img
                          src={`${url}media/${items.thumbnail}`}
                          alt=""
                          className="h-20 w-20 rounded-md md:h-32 md:w-32"
                        />
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>
          <h1 className="font-Poppins mt-10 text-3xl font-bold text-[#2260bf] md:text-[45px]">
            {category[2]?.name_nep}
          </h1>
          {/* news mini section */}
          <div className="mt-10 grid max-w-[1100px] grid-cols-1 gap-8 md:grid-cols-2">
            {news
              .filter((value) => value.category === 3)
              .slice(0, 4)
              .map((items, index) => {
                return (
                  <div key={index}>
                    <Link
                      state={{
                        category: items.category,
                      }}
                      to={`${items.category_name_eng}/${items.slug}`}
                    >
                      <div className="grid grid-cols-2">
                        <div className="trending-text">
                          {items.title.slice(0, 40)}

                          <div className="text-sm flex gap-2 text-gray-500 mt-2">
                            <svg
                              className="h-6 w-6"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 1024 1024"
                            >
                              <path
                                fill="currentColor"
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                              />
                              <path
                                fill="currentColor"
                                d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                              />
                            </svg>

                            <span> {moment(items.created_at).fromNow()}</span>
                          </div>
                        </div>
                        <img
                          src={`${url}media/${items.thumbnail}`}
                          alt=""
                          className="h-20 w-20 rounded-md md:h-32 md:w-32"
                        />
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
        {/* trending */}
        <div className="lg:w-1/3 lg:max-w-[400px]">
          <h1 className="font-Poppins mt-10 text-3xl font-bold text-[#2260bf] md:text-[45px]">
            {category[3]?.name_nep}
          </h1>
          <p className="border-lightBorder mt-2 w-full border-b" />
          <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:!grid-cols-1">
            {/* single trending item */}
            {news
              .filter((value) => value.category === 5)
              .slice(0, 6)
              .map((items, index) => {
                return (
                  <div key={index}>
                    <Link
                      state={{
                        category: items.category,
                      }}
                      to={`${items.category_name_eng}/${items.slug}`}
                    >
                      <div className="grid grid-cols-2">
                        <div className="trending-text">
                          {items.title.slice(0, 40)}

                          <div className="text-sm flex gap-2 text-gray-500 mt-2">
                            <svg
                              className="h-6 w-6"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 1024 1024"
                            >
                              <path
                                fill="currentColor"
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                              />
                              <path
                                fill="currentColor"
                                d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                              />
                            </svg>

                            <span> {moment(items.created_at).fromNow()}</span>
                          </div>
                        </div>
                        <img
                          src={`${url}media/${items.thumbnail}`}
                          alt=""
                          className="h-20 w-20 rounded-md md:h-32 md:w-32"
                        />
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      {/* ads*/}
      <div className="w-padding">
        {ad.data
          ?.filter((item) => item.id === 1)
          .map((item, index) => {
            return (
              <div
                key={index}
                className="mx-auto my-5 grid max-h-[120px] max-w-[1200px] place-content-center  text-2xl font-bold text-white"
              >
                <img
                  src={item.image}
                  alt=""
                  className="md:h-[75px] h-[25px] w-full object-fill"
                />
              </div>
            );
          })}
      </div>
      {/* news section */}
      <div className="w-padding">
        <h1 className="font-Poppins mt-10 text-3xl font-bold text-[#2260bf] md:text-[45px]">
          {category[4]?.name_nep}
        </h1>
        <div className="mt-10 grid grid-cols-1 gap-10 lg:!grid-cols-3">
          <div className="space-y-3">
            {news
              .filter((value) => value.category === 5)
              .slice(0, 2)
              .map((items, index) => {
                return (
                  <div key={index}>
                    <Link
                      state={{
                        category: items.category,
                      }}
                      to={`${items.category_name_eng}/${items.slug}`}
                    >
                      <div className="grid grid-cols-2">
                        <div className="trending-text">
                          {items.title.slice(0, 40)}

                          <div className="text-sm flex gap-2 text-gray-500 mt-2">
                            <svg
                              className="h-6 w-6"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 1024 1024"
                            >
                              <path
                                fill="currentColor"
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                              />
                              <path
                                fill="currentColor"
                                d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                              />
                            </svg>

                            <span> {moment(items.created_at).fromNow()}</span>
                          </div>
                        </div>
                        <img
                          src={`${url}media/${items.thumbnail}`}
                          alt=""
                          className="h-20 w-20 rounded-md md:h-32 md:w-32"
                        />
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>
          <div className="space-y-3">
            {news
              .filter((value) => value.category === 5)
              .slice(0, 2)
              .map((items, index) => {
                return (
                  <div key={index}>
                    <Link
                      state={{
                        category: items.category,
                      }}
                      to={`${items.category_name_eng}/${items.slug}`}
                    >
                      <div className="grid grid-cols-2">
                        <div className="trending-text">
                          {items.title.slice(0, 40)}

                          <div className="text-sm flex gap-2 text-gray-500 mt-2">
                            <svg
                              className="h-6 w-6"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 1024 1024"
                            >
                              <path
                                fill="currentColor"
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                              />
                              <path
                                fill="currentColor"
                                d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                              />
                            </svg>

                            <span> {moment(items.created_at).fromNow()}</span>
                          </div>
                        </div>
                        <img
                          src={`${url}media/${items.thumbnail}`}
                          alt=""
                          className="h-20 w-20 rounded-md md:h-32 md:w-32"
                        />
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>

          {/* ADD section */}
          <div className="space-y-2">
            <div className="w-padding">
              {ad.data
                ?.filter((item) => item.type === "square")
                .slice(0, 3)
                .map((item, index) => {
                  // console.log("here", item);
                  return (
                    <div
                      key={index}
                      className="mx-auto my-3 grid  max-w-[1200px] place-content-center text-2xl font-bold text-white"
                    >
                      <img
                        src={item.image}
                        alt=""
                        className="w-[250px] md:w-[280px] object-fill"
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      {/* end of news section */}
      {/* news slide */}
      <div className="md:w-[70rem] w-screen mt-5 md:mt-16 mx-auto">
        <h1 className="font-Poppins mt-10  mb-5 px-4 text-3xl font-bold text-[#2260bf] md:text-[45px]">
          {category[5]?.name_nep}
        </h1>
        {/* slide */}
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          className="mySwiper"
          spaceBetween={10}
          navigation={true}
          breakpoints={{
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          // onSlideChange={() => console.log("slide change")}
        >
          {" "}
          {news
            .filter((value) => value.category === 6)
            .map((items, index) => {
              return (
                <SwiperSlide>
                  <div key={index} className="item mx-auto">
                    <Link
                      state={{
                        category: items.category,
                      }}
                      to={`${items.category_name_eng}/${items.slug}`}
                      className="overflow-hidden"
                    >
                      <div className="relative h-[400px] overflow-clip w-full rounded-lg">
                        <img
                          className="h-full w-auto object-cover"
                          src={`${url}media/${items.thumbnail}`}
                          alt=""
                        />
                        <div className="absolute bottom-0 h-1/3 w-full bg-black opacity-50 blur-lg filter" />
                        <h1 className="absolute bottom-3 left-0 w-full text-center text-xl font-bold text-white">
                          {items.title}
                        </h1>
                      </div>
                    </Link>
                  </div>
                  {/* <img 
                          src={`${url}media/${items.thumbnail}`}
                          alt="" /> */}
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </div>
  );
};

export default News;
